import React, { useEffect, useRef } from 'react';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from 'icons';
import { useAuth } from 'cms/auth/auth/hooks/useAuth';
import { NavLink } from 'react-router-dom';

export const SidePanel = (props) => {
    const { title, isPaneOpen, closeHandler, isMobile, bookmarks } = props;
    const sidePanelRef = useRef(null);
    const { token } = useAuth();

    useEffect(() => {
        const handleSidePanelKeyup = (event) => {
            var key = event.code;
            if (key === 'Space' || key === 'Enter') {
                event.preventDefault();
                closeHandler();
            }
        };

        if (isPaneOpen) {
            let interval = setInterval(() => {
                let sidePanelCloseIcon = document.getElementsByClassName('slide-pane__close');
                if (sidePanelCloseIcon && sidePanelCloseIcon[0]) {
                    clearInterval(interval);
                    sidePanelCloseIcon[0].addEventListener('keyup', handleSidePanelKeyup);
                }
            }, 100);
        }

        return () => {
            let sidePanelCloseIcon = document.getElementsByClassName('slide-pane__close');
            if (sidePanelCloseIcon && sidePanelCloseIcon[0]) {
                sidePanelCloseIcon[0].removeEventListener('keyup', handleSidePanelKeyup);
            }
        };
    }, [isPaneOpen, closeHandler]);

    return (
        <>
            <div className='slidePanelContainer' ref={sidePanelRef}>
                <SlidingPane
                    className='myDNV-bookmarks-pane'
                    overlayClassName='myDNV-bookmarks-pane-overlay'
                    isOpen={isPaneOpen}
                    title={title}
                    closeIcon={
                        <div id='panel-close-icon'>
                            <FontAwesomeIcon icon={solid.faXmark} />
                        </div>
                    }
                    onRequestClose={() => {
                        // triggered on "<" on left top click or on outside click
                        closeHandler();
                    }}
                    width={isMobile ? '95%' : '45%'}
                >
                    <div className='table-wrapper'>
                        <table>
                            <thead>
                                <tr>
                                    <th>Page</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookmarks &&
                                    bookmarks.map((b, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <NavLink to={b.path}>
                                                        {b.title}
                                                    </NavLink>
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                    {/* TODO: update url */}
                    <div className='manage-bookmarks'>
                        <NavLink to='/mydnv?t=my%20bookmarks'>
                            Manage my bookmarks
                        </NavLink>
                    </div>
                </SlidingPane>
            </div>
        </>
    );
};
